import {
  UserToken as UserTokenDomainModeType,
  IUser as IUserDomainModelType
} from '../models/user';
export type UserToken = UserTokenDomainModeType;

export type IUser = IUserDomainModelType;

export const author1: IUser = {
  id: 'e7fad3b7-971d-42d8-95e8-a47e7a9f34cd',
  firstName: 'A.Matthew',
  lastName: 'Lewis',
  email: 'lewis.iopp.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0001',
  realm: 'iopp',
  status: 'active'
};

const author1Prod: IUser = {
  ...author1,
  id: 'bb4199a7-cb1e-4490-b75d-12806caf6a16'
};

const author1PreProd: IUser = {
  ...author1,
  id: 'f931a52b-90f9-4667-9689-ffb1f69163fb'
};

export const author2: IUser = {
  id: '2e92cb21-9e39-4255-9220-f23452a3427e',
  firstName: 'A.Wayne',
  lastName: 'Stark',
  email: 'stark.iopp.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0001',
  realm: 'iopp',
  status: 'active'
};

const author2Prod: IUser = {
  ...author2,
  id: '3a7ff499-02c6-4eef-bd7e-297a83bb58d5'
};

const author2PreProd: IUser = {
  ...author2,
  id: 'b02cee3c-7c59-43b2-9929-1abfb91d8354'
};

const editor1: IUser = {
  id: '5c41d136-b77c-4434-996b-c7591526c510',
  firstName: 'E.Rodger',
  lastName: 'Stancy',
  email: 'stancy.iopp.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0002',
  realm: 'iopp',
  status: 'active'
};

const editor1Prod: IUser = {
  ...editor1,
  id: '1a3aede3-3f5e-46d1-b8ec-dd758a2567e7'
};

const editor1PreProd: IUser = {
  ...editor1,
  id: '01bc0065-dd3f-4807-a94c-9bb7e3cc201a'
};

const editor2: IUser = {
  id: 'edebc217-cb67-450c-9fb5-97ac324e5901',
  firstName: 'E.Amina',
  lastName: 'Patel',
  email: 'patel.iopp.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0003',
  realm: 'iopp',
  status: 'active'
};

const editor2Prod: IUser = {
  ...editor2,
  id: 'b6f5011d-36f9-42f9-80de-d94edd851a0a'
};

const editor2PreProd: IUser = {
  ...editor2,
  id: 'b5115f13-6f3c-44d6-af7a-563c814ecafa'
};

const editor3: IUser = {
  id: 'd12ca502-138a-466e-a069-4e2dcd5e5343',
  firstName: 'E.Diego',
  lastName: 'Alvarez',
  email: 'alvarez.iopp.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0004',
  realm: 'iopp',
  status: 'active'
};

const editor3Prod: IUser = {
  ...editor3,
  id: 'a896267f-c4fe-4b32-9b64-a1ae947e2968'
};

const editor3PreProd: IUser = {
  ...editor3,
  id: '3d4d7006-f20f-4f40-9879-7d90d0841ada'
};

const editor4: IUser = {
  id: '4cb7ac1d-0c3d-4cac-8773-628e67479d0b',
  firstName: 'E.Chen',
  lastName: 'Wei',
  email: 'wei.iopp.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0005',
  realm: 'iopp',
  status: 'active'
};

const editor4Prod: IUser = {
  ...editor4,
  id: '82dd6353-46b1-464b-be30-a28176f61f8b'
};

const editor4PreProd: IUser = {
  ...editor4,
  id: '3b77991a-334d-4450-8f6c-8cbbdba93c5b'
};

const reviewer2: IUser = {
  id: 'b244bcea-a7e0-44ff-8f7b-42e4222f6312',
  firstName: 'R.John',
  lastName: 'Doe',
  email: 'doe.iopp.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0006',
  realm: 'iopp',
  status: 'active'
};

const reviewer2Prod: IUser = {
  ...reviewer2,
  id: '30f8e62d-3e4b-4583-bd89-8df94be2c5bf'
};

const reviewer2PreProd: IUser = {
  ...reviewer2,
  id: 'eb035033-9aaa-49e2-8dab-fc84def91aee'
};

const reviewer3: IUser = {
  id: 'f9dea88a-bdd8-4c3d-b86d-ac1f6c4a7c92',
  firstName: 'R.Monalisa',
  lastName: 'Paine',
  email: 'paine.iopp.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0007',
  realm: 'iopp',
  status: 'active'
};

const reviewer3Prod: IUser = {
  ...reviewer3,
  id: 'cbe375ee-ad17-489e-85f4-a63e59d661b4'
};

const reviewer3PreProd: IUser = {
  ...reviewer3,
  id: '509ec35a-6457-453f-8433-f5cc59636b36'
};

const reviewer1: IUser = {
  id: '997ef0f4-da71-4bac-8e46-e4014aa8eb64',
  firstName: 'R.Teniola',
  lastName: 'Page',
  email: 'page.iopp.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0008',
  realm: 'iopp',
  status: 'active'
};

const reviewer1Prod: IUser = {
  ...reviewer1,
  id: '1c311c72-e27b-4214-8e5d-8fc64a42d3c1'
};

const reviewer1PreProd: IUser = {
  ...reviewer1,
  id: '8e9850d9-c303-4d75-9337-e9c4c5afbfa8'
};

const orgAdmin1: IUser = {
  id: '47e15a57-6497-4453-b09f-936cc877c479',
  firstName: 'O.Oscar',
  lastName: 'Odin',
  email: 'odin.iopp.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0009',
  realm: 'iopp',
  status: 'active'
};

const orgAdmin1Prod: IUser = {
  ...orgAdmin1,
  id: '4fde0bef-b43c-4b1a-baa8-cede0c489268'
};

const orgAdmin1PreProd: IUser = {
  ...orgAdmin1,
  id: 'cbf5e3fa-62aa-4ab6-8a1c-3d13100badd8'
};

const sysAdmin1: IUser = {
  id: '93364ab4-cdc6-4f5c-a6c0-df3892feb256',
  firstName: 'Sudo',
  lastName: 'User',
  email: 'sudo.iopp.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0010',
  realm: 'iopp',
  status: 'active'
};

const sysAdmin1Prod: IUser = {
  ...sysAdmin1,
  id: '43d6b54c-d378-42ee-ad57-d61b4ed56d6a'
};

const sysAdmin1PreProd: IUser = {
  ...sysAdmin1,
  id: 'd86713da-46cb-4036-a280-7422493352c6'
};

const boardMember1: IUser = {
  id: '16815c99-8aa9-44f1-9e20-079c39e833d3',
  firstName: 'B.Benjamin',
  lastName: 'Clark',
  email: 'bclark.board.iopp.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0011',
  realm: 'iopp',
  status: 'active'
};

const boardMember1Prod: IUser = {
  ...boardMember1,
  id: 'ac3d1743-09d1-4c7c-937c-e20c49003563'
};

const boardMember1PreProd: IUser = {
  ...boardMember1,
  id: 'bf92e51b-3fef-4d0f-a070-98c633f62192'
};

const boardMember2: IUser = {
  id: 'feb5efff-2fa4-4855-b982-0396dacf6a4e',
  firstName: 'B.Bianca',
  lastName: 'Rivera',
  email: 'brivera.board.iopp.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0012',
  realm: 'iopp',
  status: 'active'
};

const boardMember2Prod: IUser = {
  ...boardMember2,
  id: '8050b626-1285-4f29-997b-2503f137f20b'
};

const boardMember2PreProd: IUser = {
  ...boardMember2,
  id: 'fcc490bf-7cc5-49d1-9f71-a14105927372'
};

const boardMember3: IUser = {
  id: '9817db19-0d02-4a6f-846c-a0194c9a72f6',
  firstName: 'B.Brianna',
  lastName: 'Patel',
  email: 'bpatel.board.iopp.ixh4joki@mailosaur.io',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: 'https://orcid.org/0000-0000-0000-0013',
  realm: 'iopp',
  status: 'active'
};

const boardMember3Prod: IUser = {
  ...boardMember3,
  id: 'f75b8b4e-e3b8-4867-b69c-607514921623'
};

const lucy: IUser = {
  id: 'e81ca1e1-bed0-40ab-aa74-74a9f1dcdade',
  firstName: 'Lucy',
  lastName: 'Loftus',
  email: 'lucy.loftus@ioppublishing.org',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '',
  realm: 'iopp',
  status: 'active'
};

const sam: IUser = {
  id: '5d8de5bd-a826-4d29-a835-31f18442e047',
  firstName: 'Sam',
  lastName: 'Parsons',
  email: 'sam.parsons@ioppublishing.org',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '',
  realm: 'iopp',
  status: 'active'
};

const jack: IUser = {
  id: '86add9a1-3620-4546-80dd-32316cbd1beb',
  firstName: 'Jack',
  lastName: 'Henley',
  email: 'Jack.Henley@ioppublishing.org',
  affiliationDetails: {
    organizationName: 'Moreton Morrell College',
    streetAddress: 'Moreton Morrell, England, Warwickshire, GB',
    city: 'Moreton Morrell',
    stateOrRegion: 'England',
    postalCode: '235235',
    country: 'United Kingdom',
    countryCode: 'GB',
    url: 'wcg.ac.uk/moretonmorrell',
    ringgoldId: '347566'
  },
  orcid: '',
  realm: 'iopp',
  status: 'active'
};

const boardMember3PreProd: IUser = {
  ...boardMember3,
  id: 'f75b8b4e-e3b8-4867-b69c-607514921623'
};

export const STAGING_USERS_MAP = {
  author1,
  author2,
  editor1,
  editor2,
  editor3,
  editor4,
  reviewer1,
  reviewer2,
  reviewer3,
  boardMember1,
  boardMember2,
  boardMember3,
  orgAdmin1,
  sysAdmin1
} as const;

export const STAGING_REVIEWERS = {
  reviewer1,
  reviewer2,
  reviewer3
} as const;

export const PROD_USERS_MAP = {
  author1: author1Prod,
  author2: author2Prod,
  editor1: editor1Prod,
  editor2: editor2Prod,
  editor3: editor3Prod,
  editor4: editor4Prod,
  reviewer1: reviewer1Prod,
  reviewer2: reviewer2Prod,
  reviewer3: reviewer3Prod,
  boardMember1: boardMember1Prod,
  boardMember2: boardMember2Prod,
  boardMember3: boardMember3Prod,
  orgAdmin1: orgAdmin1Prod,
  sysAdmin1: sysAdmin1Prod,
  orgAdmin2: lucy,
  orgAdmin3: sam,
  orgAdmin4: jack
} as const;

export const PREPROD_USERS_MAP = {
  author1: author1PreProd,
  author2: author2PreProd,
  editor1: editor1PreProd,
  editor2: editor2PreProd,
  editor3: editor3PreProd,
  editor4: editor4PreProd,
  reviewer2: reviewer2PreProd,
  reviewer3: reviewer3PreProd,
  reviewer1: reviewer1PreProd,
  boardMember1: boardMember1PreProd,
  boardMember2: boardMember2PreProd,
  boardMember3: boardMember3PreProd,
  orgAdmin1: orgAdmin1PreProd,
  sysAdmin1: sysAdmin1PreProd
} as const;

export const STAGING_BOARDMEBMERS = {
  boardMember1,
  boardMember2,
  boardMember3
} as const;
